import { Row, Checkbox, Space } from 'antd';
import { useRef } from 'react';
import { useIntl } from 'react-intl';

import Messages from 'i18n/messages/reporting';

import { ADVANCED_FILTER_MODE } from 'pages/reporting/utils/constants';
import DataSwitchButton from 'pages/reporting/components/DataSwitchButton';
import TitleSection from 'pages/reporting/components/TitleSection';
import SearchProperties from 'pages/reporting/components/SearchProperties';

const HeaderEntityAttributes = ({
  type,
  children,
  viewMode,
  modeData,
  onClick,
  allPopulated,
  onChangeAllPopulated,
  handleUpdateSearchEntity,
}) => {
  const intl = useIntl();
  const refSearchText = useRef();

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <TitleSection title={'Entities and Attributes'}>
        <Space size={8}>
          {onChangeAllPopulated && (
            <Checkbox
              checked={allPopulated}
              disabled={viewMode}
              onChange={onChangeAllPopulated}
            >
              {intl.formatMessage(Messages.allPopulatedFields)}
            </Checkbox>
          )}
          <div style={{ pointerEvents: viewMode ? 'none' : 'auto' }}>
            {type === 'product' && (
              <DataSwitchButton
                checked={modeData === ADVANCED_FILTER_MODE.FLAT_DATA}
                onClick={() => onClick(refSearchText)}
              />
            )}
          </div>
        </Space>
      </TitleSection>
      <Row className='advanced-reporting__header-reporting'>
        <SearchProperties
          entityType={type}
          ref={refSearchText}
          handleUpdateSearchEntity={handleUpdateSearchEntity}
        />
      </Row>
      <div style={{ height: 'calc(100% - 88px)' }}>{children}</div>
    </div>
  );
};

export default HeaderEntityAttributes;
